import axios from 'axios'
import config from '@/config/config'
import store from '@/store/store'

// Circular Dependenciesを避けるため BaseRequestをextendsしない
export default class ItemRequest {
  constructor() {
    this.baseUrl = config.apiBaseUrl

    const lang = store.getters['settings/getLanguage']
    axios.defaults.headers.common['Language-Id'] = lang

    if (store.getters['oauth/isLogin']) {
      const token = store.getters['oauth/getToken']
      axios.defaults.headers.common['adminAuthToken'] = token.accessToken

      if (config.alibabaCloudAppcode !== '') {
        axios.defaults.headers.common['Authorization'] =
          'APPCODE ' + config.alibabaCloudAppcode
      }
    }
  }

  getList() {
    return axios.get(`${this.baseUrl}/admin/items/`)
  }

  getById(id) {
    return axios.get(`${this.baseUrl}/admin/items/?itemCode=${id}`)
  }

  insert(params) {
    return axios.post(`${this.baseUrl}/admin/items/insert/`, params)
  }

  update(id, params) {
    return axios.post(`${this.baseUrl}/admin/items/update/${id}`, params)
  }

  delete(id) {
    return axios.post(`${this.baseUrl}/admin/items/delete/${id}`)
  }

  uploadImage(params) {
    return axios.post(`${this.baseUrl}/admin/items/image/upload/`, params)
  }

  uploadImages(formData) {
    return axios.post(`${this.baseUrl}/admin/items/images/upload/`, formData)
  }

  deleteImage(params) {
    return axios.post(`${this.baseUrl}/admin/items/image/delete/`, params)
  }

  getTags() {
    return axios.get(`${this.baseUrl}/admin/items/tags/`)
  }

  addTag(params) {
    return axios.post(`${this.baseUrl}/admin/items/tags/add/`, params)
  }

  deleteTag(tagId, itemCode) {
    return axios.post(
      `${this.baseUrl}/admin/items/tags/delete/${tagId}/${itemCode}/`
    )
  }

  getKinds() {
    return axios.get(`${this.baseUrl}/admin/items/kinds`)
  }

  getToppings() {
    return axios.get(`${this.baseUrl}/admin/toppings`)
  }
}
